
export const Theme = {
  input: [
    'w-4 h-4 text-primary-500 border-neutral-200 cursor-pointer',
    'focus:ring-2 focus:ring-primary-500',
    'disabled:text-neutral-400 disabled:cursor-not-allowed',
    'dark:ring-offset-gray-800 dark:border-gray-600',
    'dark:focus:ring-primary-500'
  ],
  label: [
    'text-sm text-gray-900 ml-4 cursor-pointer',
    'dark:text-gray-300'
  ],
  labelDisabled: [
    'cursor-default',
    'text-neutral-400',
    'dark:text-gray-500'
  ]
};
